/* import __COLOCATED_TEMPLATE__ from './pull-data-from-salesforce.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import templateOnlyComponent from '@ember/component/template-only';

interface Args {
  isSettingsPage?: boolean;
  isMessengerPage?: boolean;
}

const StandaloneSalesforceSetupPullDataFromSalesforce = templateOnlyComponent<Args>();
export default StandaloneSalesforceSetupPullDataFromSalesforce;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Salesforce::Setup::PullDataFromSalesforce': typeof StandaloneSalesforceSetupPullDataFromSalesforce;
    'standalone/salesforce/setup/pull-data-from-salesforce': typeof StandaloneSalesforceSetupPullDataFromSalesforce;
  }
}
